<template>
    <WorkspacesComp />
</template>

<script>
import WorkspacesComp from '@/components/user/workspaces/WorkspacesComp.vue'
import Auth from '@/services/auth.service.js'

export default {
    name: 'WorkspacesView',
    components: {
        WorkspacesComp
    },
    mounted() {
        document.title = 'סביבות עבודה | CLICKCALL';

        console.log('WorkspacesView mounted');
        
        let auth = Auth.checkAuth();
        if (!auth) {
            this.$router.replace({ name: "login" });
        }

    },
}
</script>
